declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export const GA4_ID = process.env.NEXT_PUBLIC_GA4_ID;
export const GOOGLE_ADS_ID = 'AW-18154106713';
export const SIGNUP_CONVERSION =
  process.env.NEXT_PUBLIC_GOOGLE_ADS_SIGNUP_CONVERSION ??
  'AW-18154106713/D38LCNSk2rEcENnextBD';

const LINKER_DOMAINS = ['getlinkai.com', 'dashboard.getlinkai.com'] as const;

export const GTAG_LINKER_CONFIG = {
  linker: { domains: [...LINKER_DOMAINS] },
  send_page_view: false,
} as const;

const isProduction = process.env.NODE_ENV === 'production';

function gtag(...args: unknown[]) {
  if (!isProduction || typeof window === 'undefined' || !window.gtag) return;
  window.gtag(...args);
}

export function trackPageView(pagePath: string) {
  gtag('event', 'page_view', {
    page_path: pagePath,
  });
}

export function trackSignup(params?: { method?: string }) {
  gtag('event', 'signup', {
    event_category: 'conversion',
    method: params?.method ?? 'email',
  });
  gtag('event', 'conversion', {
    send_to: SIGNUP_CONVERSION,
  });
}

export function trackOnboardingComplete() {
  gtag('event', 'onboarding_complete', {
    event_category: 'engagement',
  });
}
